import wx from "weixin-js-sdk";
import axios from 'axios';
// 引用全局
/* eslint-disable */
const jsApiList = [
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'onMenuShareAppMessage',
  'onMenuShareTimeline'
];

// 要用到微信API
function getJSSDK(url,dataForWeixin) {
  // 调用后台接口换取参数
  axios.post('/api/web/systemconfig/signature',{'url':url}).then((res) => {
  if (res.status===200 && res.data.data) {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.data.signature, // 必填，签名
      jsApiList, // 必填，需要使用的JS接口列表
    }); 
    wx.ready(() => {
      wx.onMenuShareAppMessage({
        title: dataForWeixin.title,
        desc: dataForWeixin.desc,
        link: dataForWeixin.linkurl,
        imgUrl: dataForWeixin.img,
        success: function success(res) {
          // alert('成功!' + imgUrl)
        },
        cancel: function cancel(res) {
          // alert('取消' + JSON.stringify(res))
        },
        fail: function fail(res) {
          // alert('错误' + JSON.stringify(res))
        },
      });
      wx.onMenuShareTimeline({
        title: dataForWeixin.title,
        desc: dataForWeixin.desc,
        link: dataForWeixin.linkurl,
        imgUrl: dataForWeixin.img,
        success: function success(res) {
          // alert('成功!' + imgUrl)
        },
        cancel: function cancel(res) {
          // alert('取消' + JSON.stringify(res))
        },
        fail: function fail(res) {
          // alert('错误' + JSON.stringify(res))
        },
      });
      wx.updateAppMessageShareData({
        title: dataForWeixin.title,
        desc: dataForWeixin.desc,
        link: dataForWeixin.linkurl,
        imgUrl: dataForWeixin.img,
        success: function success(res) {
          // alert('成功!' + imgUrl)
        },
        cancel: function cancel(res) {
          // alert('取消' + JSON.stringify(res))
        },
        fail: function fail(res) {
          // alert('错误' + JSON.stringify(res))
        },
      });
      wx.updateTimelineShareData({
        title: dataForWeixin.title,
        desc: dataForWeixin.desc,
        link: dataForWeixin.linkurl,
        imgUrl: dataForWeixin.img,
        success: function success(res) {
          // alert('成功!' + imgUrl)
        },
        cancel: function cancel(res) {
          // alert('取消' + JSON.stringify(res))
        },
        fail: function fail(res) {
          // alert('错误' + JSON.stringify(res))
        },
      });
    });
    wx.error((res) => {
      // alert('失败' + JSON.stringify(res))
    });
  }
  });
}
export default {
  // 获取JSSDK
  getJSSDK,
};